import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
declare const mapUtilityMapBox;
declare var google: any;
declare var $: any;

@Injectable()


export class MapService {

    public mapKey = 'pk.eyJ1Ijoib3dlbmxhbWIiLCJhIjoiY2lleWljcnF4MDBiOXQ0bHR0anRvamtucSJ9.t3YnHHqvQZ8Y0MTCNy0NNw';
    public MyMap = new mapUtilityMapBox();
    public mapValue: any;
    constructor(private http: HttpClient){

    }
    retMap() {
        return { mymap: this.MyMap, key: this.mapKey };
    }

    map(elemId) {
        return new Promise((resolve, reject) => {
            try {
                this.MyMap.setup(elemId, {
                    key: this.mapKey
                },
                    (map) => {

                        resolve(map);

                    });
            } catch (error) {

                reject(error);
            }
        });
    }

    geoCoding(address) {
        return new Promise((resolve, reject) => {
            this.MyMap.geocoder(
                address, (res) => {
                    try {
                        // console.log(res.features);
                        let location = res.features.map((i) => { return { center: i.center, name: i.place_name } });
                        resolve(location);
                    } catch (er) { reject(er); }
                }, this.mapKey);
        });
    }

    loadMap(id: string, markers: any,cluster=[]) {
        this.MyMap.setup(id, {
            key: this.mapKey
        }, (map) => {
            this.mapValue = map;
            if(cluster.length>0){
                map.clusters = cluster;
            }
            map.addMarkers(markers);
            setTimeout(() => {
                map.clusterSynch();
              }, 500);
              
              map.onMapZoom(function (z) {
                map.clusterSynch();
                setTimeout(() => { map.marker(markers); }, 200);
              });
            map.focus({
                zoom: 18
            });
            //  map.onClick({
            //     type : 'marker', // marker --or-- cluster
            //     id :  'B'// null , // null --or-- specific marker id  or cluster name
            //    },function(e){
            //     console.log('@@@@@@@@@@@----> ',e)
            //   });

        });
    }

    updateMarker(data) {

        if (this.mapValue) {
            this.mapValue.marker(data);
            this.mapValue.clusterSynch();
        }
    }

    focus(id:string,obj:any){
        this.MyMap.setup(id, {
            key: this.mapKey
        }, (map) => {
            this.mapValue = map;
            map.focus(obj);
            //  map.onClick({
            //     type : 'marker', // marker --or-- cluster
            //     id :  'B'// null , // null --or-- specific marker id  or cluster name
            //    },function(e){
            //     console.log('@@@@@@@@@@@----> ',e)
            //   });

        });
    }

    cluster(id:string,val:any){
        this.MyMap.setup(id, {
            key: this.mapKey
        }, (map) => {
            this.mapValue = map;
            map.cluster = val;
           
        });
    }
    clusterSycn(id:string){
        this.MyMap.setup(id, {
            key: this.mapKey
        }, (map) => {
            this.mapValue = map;
            map.clusterSynch();
           
        }); 
    }

    flatLine(id: string, points: any) {

        this.MyMap.setup(id, {
            key: this.mapKey
        }, (map) => {
            map.addLine(points);
            //    let url = "./assets/map_images/arrow.png"
            //    map.loadImage(url, function(err, image) {
            //     if (err) {
            //       console.error('err image', err);
            //       return;
            //     }
            //     else console.log("no err");
            //    map.addImage('arrow', image);
            //     map.addLayer({
            //     'id': 'arrow-layer',
            //     'type': 'symbol',
            //     'source': 'mapDataSourceId',
            //     'layout': {
            //         'symbol-placement': 'line',
            //         'symbol-spacing': 1,
            //         'icon-allow-overlap': true,
            //         // 'icon-ignore-placement': true,
            //         'icon-image': 'arrow',
            //         'icon-size': 0.045,
            //         'visibility': 'visible'
            //     }
            //     });
            // });
        });
    }
    removeLine(id: string){
        this.MyMap.setup(id, { key: this.mapKey }, (map) => { 
            // map.removeLine(id); 
            map.removeLineAll(); 
        });        
    }
    marker(id: string,markers){
        this.MyMap.setup(id, { key: this.mapKey }, (map) => { 
            // map.removeLine(id); 
            map.marker(markers); 
        });    
    }
    removeMarkerAll(id:string){
        this.MyMap.setup(id, { key: this.mapKey }, (map) => { 
            // map.removeLine(id); 
            map.removeMarkerAll(); 
        });    
    }

    addMarker(id: string,markers){
        this.MyMap.setup(id, { key: this.mapKey }, (map) => { 
            // map.removeLine(id); 
            map.addMarkers(markers); 
        });    
    }

    gMapGeocoder(obj){
        return new Promise(async (resolve,reject)=>{            
            let results = []
            try{               
                $.ajax({
                    url: "https://maps.googleapis.com/maps/api/geocode/json",
                    type: 'GET',
                    data: {
                        ...obj,
                        key: 'AIzaSyADOzQlHAusYj40R8m50JPnHkMETEFUDT4',//'AIzaSyCPTEKpIbkqcr-e2Vr69_rWBIgekyMwkPc'
                    },
                    dataType: 'json',   
                    // cache: false,
                    // contentType: false, // Tell jQuery not to process data or worry about content-type
                    //  processData: false, // You must include these options              
                    //   beforeSend: function(xhr){
                    //                 xhr.setRequestHeader('token',apiToken);
                    //                 // xhr.setRequestHeader('vendorID',params.vendorID);
                    //             },
                    success: (data) => {
                        try{
                            if(data && data.results && data.results.length>0){
                                resolve(data.results);
                            }else reject({'error':'No results found'});
                        }catch(err){
                            reject(err);
                        }                        
                    },
                    error: (xhr,status,error) =>{
                        reject(error);
                    }
                });
            }catch(err){
                console.log(err);
                reject(err);
            }
        })
    }

}

export interface Geocoding {
    results: GeocodingResult[];
    status: string;
  }
  
  export interface GeocodingResult {
    types: string[];
    formatted_address: string;
    address_components: {
      short_name: string;
      long_name: string;
      postcode_localities: string[];
      types: string[];
    }[];
    partial_match: boolean;
    place_id: string;
    postcode_localities: string[];
    geometry: {
      location: LatLng;
    };
  }
  
  export interface LatLng {
    lat: number;
    lng: number;
  }
